import {
  Box,
  Button,
  Center,
  Table,
  TableCaption,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React from "react";
import moment from "moment";
export const ModalHistoricoAlteracao = (dados) => {
  return (
    <Box fontFamily="Akrobat" mt="1rem" w="100%">
      <Box overflowY="scroll" maxH="250px">
        <Table size="sm" variant="striped" colorScheme="blackAlpha">
          <TableCaption fontFamily="Akrobat ExtraBold">
            Tabela de Histórico de Vendedor
          </TableCaption>
          <Thead>
            <Tr>
              <Th>Transferido em</Th>
              <Th>Horário</Th>
              <Th>Alterado por</Th>
            </Tr>
          </Thead>
          <Tbody>
            {dados.historico.map(item=>{
              return  <Tr>
                        <Td>{moment(item.data_alteracao).format('DD/MM/YYYY')}</Td>
                        <Td>{moment(item.data_alteracao).format('hh:mm:ss')}</Td>
                        <Td>{item.nome_usuario.trim()}</Td>
                      </Tr>
            })}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};
